import React, { useEffect } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { LanguageProvider } from './contexts/LanguageContext';
// Set page title
if (typeof document !== 'undefined') {
  document.title = 'Преміум Ательє | На 5 поверхів';
}
function AppWrapper() {
  useEffect(() => {
    document.title = 'Преміум Ательє | На 5 поверхів';
  }, []);
  return <LanguageProvider data-id="element-281">
      <App data-id="element-282" />
    </LanguageProvider>;
}
render(<AppWrapper data-id="element-283" />, document.getElementById('root'));